export enum PaymentFrequency {
  BiWeekly = 'B',
  Monthly = 'M',
  Weekly = 'W',
}
